import type { Action } from '@ngrx/store';
import type { Branding } from '../../interfaces/Branding.interface';

export enum ActionType {
    FETCH_BRANDING = '[BRANDING] FETCH_BRANDING',
    FETCH_BRANDING_SUCCEEDED = '[BRANDING] FETCH_BRANDING_SUCCEEDED',
    FETCH_BRANDING_FAILED = '[BRANDING] FETCH_BRANDING_FAILED'
}

export class FetchBranding implements Action {
    readonly type = ActionType.FETCH_BRANDING;
}

export class FetchBrandingSucceeded implements Action {
    readonly type = ActionType.FETCH_BRANDING_SUCCEEDED;
    constructor(
        readonly payload: {
            branding: Branding;
        }
    ) {}
}

export class FetchBrandingFailed implements Action {
    readonly type = ActionType.FETCH_BRANDING_FAILED;
}

export type Actions = FetchBranding | FetchBrandingSucceeded | FetchBrandingFailed;
